<template>
  <PopupTemplate @close="$emit('close')">
    <div>
      <div v-if="paso == 'pedirPassword'" class="panel pure-form">
        <div class="cabecera">
          Escribe una contraseña
        </div>

        <div class="texto">
          Debe tener al menos 8 caracteres alfanuméricos
        </div>

        <label for="uname1"><strong>Contraseña</strong></label>
        <input
          id="uname1"
          v-model.trim="clave1"
          type="password"
          placeholder="Escribe una contraseña"
          required
        />

        <div class="sep" />
        <label for="uname2"><strong>Repite la contraseña</strong></label>
        <input
          id="uname2"
          v-model.trim="clave2"
          type="password"
          placeholder="Repite la contraseña"
          required
        />

        <PanelMensajes :mensaje="error" clase="error" />

        <button type="submit" class="pure-button" @click.prevent="siguiente()">
          <strong>Siguiente</strong>
        </button>
      </div>

      <div v-if="paso == 'resultado'" class="panel">
        Contraseña actualizada correctamente.
        <button @click.prevent="siguiente()">Finalizar</button>
      </div>
    </div>
  </PopupTemplate>
</template>

<script>
export default {
  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      paso: "pedirPassword",
      clave1: "",
      clave2: "",
      error: "",
    };
  },

  methods: {
    siguiente: async function() {
      let resp;
      switch (this.paso) {
        case "pedirPassword":
          resp = await this.$store.dispatch("actualizarPasswordCliente", {
            clave1: this.clave1,
            clave2: this.clave2,
          });
          console.log(resp);
          if (resp.codigo != 0) {
            this.error = resp.mensaje;
            return;
          }
          this.paso = "resultado";
          break;

        case "resultado":
          this.$emit("close");
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.cabecera {
  font-size: 120%;
  margin-bottom: 1rem;
  color: $colorMMT;
  border-bottom: 2px solid $azulOscuroMMT;
}

.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}

.panel {
  display: flex;
  flex-flow: column nowrap;
  label {
    display: block;
  }
  input {
    width: 100%;
  }
  button {
    background-color: $colorMMT;
    color: white;
    margin-top: 1rem;
  }
}

.contenedor {
  width: 100%;
  max-width: 30rem;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 5px;
  padding: 2rem;
}

.sep {
  height: 0.8rem;
}

input {
  width: 100%;
  min-width: 15rem;
}
</style>
